import { fetchData } from 'services/fetchData';

import { authStore } from 'stores';

/**
 * Send a request to the API to create a new Account.
 * @param {Object} newAccount details of the new Account.
 * @returns the newly created Account.
 */
export const createAccount = async (newAccount) => {
    const { jwtToken } = authStore.getState('passwordSession').value.sessionDetails;

    const httpOptions = {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${jwtToken}`,
            'Content-Type': 'application/json'
        },
        withCredentials: true,
        body: JSON.stringify(newAccount)
    };

    const requestPath = `/account`;
    const { data } = await fetchData(requestPath, httpOptions);
    return data;
};
